import React, {useState} from 'react';
import {Footer, TopNavBar} from '../../components'
import {withRouter} from "react-router-dom";
import {Grid} from "@material-ui/core";
import './styles.scss'
import CheckoutForm from "./checkoutForm";
import PaymentSection from './paymentSection'
import {initialState} from "./constant";
import HttpService from "../../services/http.service";
import {validateInputs} from "../../services/utils";
import Alert from "../../components/alert";
function Index(props) {

  const [state, setState] = useState(initialState)
  const [paymentMethod, setPaymentMethod] = useState('COD')
  const [error, setError] = useState("")
  const [success, setSuccess] = useState("")
  const {values, errors} = state;
  const data = props.location?.data
   let dataFinal = []
  if(data){
  for (let i = 0; i < data.length; i++) {
    dataFinal.push({
      "addDate": "2022-01-01T15:02:27.055Z",
      "contactNumber": "string",
      "harvestId": {
        "avgWtSize": 0,
        "bidExpiredStatus": "string",
        "broadcastDate": "2022-01-01T15:02:27.055Z",
        "cityId": 0,
        "cropCutDate": "2022-01-01T15:02:27.055Z",
        "currency": "string",
        "digitalCurrAllowed": "string",
        "expectedHarvestDate": "2022-01-01T15:02:27.055Z",
        "expectedYield": 0,
        "fileBucket": {
          "description": "string",
          "fileArray": [
            null
          ],
          "fileName": "string",
          "harvestId": "string",
          "minPrice": "string",
          "quantity": "string",
          "ssoId": "string"
        },
        "gardingRequested": "string",
        "gradedBy": "string",
        "gradedBy2": "string",
        "gradedDate": "2022-01-01T15:02:27.055Z",
        "gradedDate2": "2022-01-01T15:02:27.055Z",
        "gradeingDate": "2022-01-01T15:02:27.055Z",
        "gradeingDate2": "2022-01-01T15:02:27.055Z",
        "harvestId": data[i].harvestId?.harvestId,
        "imagePath": "string",
        "initialImageApproved": "string",
        "insuranceCertificate": "string",
        "insuranceDetails": "string",
        "insurerName": "string",
        "isEnsured": "string",
        "isFeaturedProduct": "string",
        "manPowerRequested": "string",
        "moistureValuePtg": 0,
        "moq": 0,
        "nutrientValue": "string",
        "pmtGwllowed": "string",
        "priceSetByVendor": 0,
        "productDesciption": "string",
        "publishImmediately": "string",
        "purchaseDate": "2022-01-01T15:02:27.055Z",
        "purchasedFrom": "string",
        "qty": 0,
        "qtyName": "string",
        "sectorId": {
          "agriSectorDescription": "string",
          "agriSectorId": 0,
          "categories": [
            {}
          ],
          "sectorCategory": "string",
          "sectorImage": "string"
        },
        "sectorIdStr": "string",
        "subSpeciesName": "string",
        "transactionId": "string",
        "transportationRequested": "string",
        "userId": {
          "businessSelected": "string",
          "city": "string",
          "country": "string",
          "countryCode": "string",
          "email": "string",
          "firstName": "string",
          "id": 0,
          "joinDate": "2022-01-01T15:02:27.055Z",
          "lastName": "string",
          "latitudes": "string",
          "longitues": "string",
          "mobileNumber": "string",
          "otp": "string",
          "password": "string",
          "preferedLanguage": "string",
          "provider": "string",
          "socialId": "string",
          "ssoId": "string",
          "userImage": "string",
          "userProfiles": [
            {
              "id": 0,
              "type": "string"
            }
          ]
        },
        "yieldDetailId": 0
      },
      "harvestName": "string",
      "itemStatus": "string",
      "myCartItemsId": data[i].myCartItemsId,
      "productQty": 0,
      "shippingAddress": "string",
      "ssoId": "string",
      "unitPrice": 0
    })
  }
  }

  function addOrder(params) {
    let data1 = {address: values.address}
    let recordedErrors = validateInputs(data1);
    if (Object.keys(recordedErrors).length > 0) {
      console.log("error", recordedErrors);
      setState((prevState) => ({
        ...prevState,
        errors: recordedErrors,
      }));
    } else {
      HttpService.post(`api/bulk/save?customerName=${values.firstName}&shippingAddress=${values.address}`, dataFinal).then(res => {
        if (res) {
          if (res?.data?.message == "Success"){
            setSuccess(res?.data?.messageText)
          setTimeout(() => {
            setSuccess("")
             props.history.push({
      pathname: '/'
    })
          }, 5000);
          } else{
          setError(res?.data?.messageText)
        setTimeout(() => {
          setError("")
        }, 8000);
          }
    }
    })
    }
  }

  return (
    <>
      <TopNavBar/>
     {((error || success)) && <Alert type={error ? 'error' : 'success'} message={error || success}/>}
      <Grid container className='content-container ' justify={'space-between'}
            style={{marginBottom: 60, padding: '30px 5%'}}>

        <CheckoutForm state={state} setState={setState}/>
        <PaymentSection addOrder={addOrder} paymentMethod={paymentMethod} setPaymentMethod={setPaymentMethod}/>
      </Grid>
      <Footer/>
    </>
  );
}

export default withRouter(Index);
